import Component from "@glimmer/component"
import type { PrismicDoc } from "@shared/models/prismic-article"
import styles from "./prismic-article.module.css"

interface Args {
  prismicDoc: PrismicDoc
}
export default class KbPrismicComponent extends Component<Args> {
  readonly styles = styles
}
